export default "__VITE_ASSET__CvPVDgZ3__"